import type { AnimationPreset } from '@base/types/animations';

export const ANIMATION_PRESETS: Record<string, AnimationPreset> = {
  'reveal': {
    enter: {
      name: 'reveal',
      duration: 1300,
      easing: 'cubic-bezier(.19, 1, .22, 1)',
    },
    leave: {
      name: 'leave',
      duration: 300,
      easing: 'cubic-bezier(.785, .135, .15, .86)',
    },
  },
  'fade': {
    enter: {
      name: 'fadeIn',
      duration: 500,
      easing: 'ease-in-out',
    },
    leave: {
      name: 'fadeOut',
      duration: 300,
      easing: 'ease-in-out',
    },
  },
  'slide': {
    enter: {
      name: 'slideIn',
      duration: 600,
      easing: 'cubic-bezier(.47, 1.64, .41, .8)',
    },
    leave: {
      name: 'slideOut',
      duration: 400,
      easing: 'ease-in',
    },
  },
  'scale': {
    enter: {
      name: 'scaleIn',
      duration: 500,
      easing: 'cubic-bezier(.47, 1.64, .41, .8)',
    },
    leave: {
      name: 'scaleOut',
      duration: 300,
      easing: 'ease-out',
    },
  },
  'bounce': {
    enter: {
      name: 'bounceIn',
      duration: 800,
      easing: 'cubic-bezier(.47, 1.64, .41, .8)',
    },
    leave: {
      name: 'bounceOut',
      duration: 400,
      easing: 'ease-in',
    },
  },
  'message-sent': {
    enter: {
      name: 'message-sent',
      duration: 250,
      easing: 'ease',
    },
    leave: {
      name: 'message-sent',
      duration: 250,
      easing: 'ease',
    },
  },
  'banner-slide-vertical': {
    enter: {
      name: 'banner-slide-vertical',
      duration: 350,
      easing: 'cubic-bezier(.22, 1, .36, 1)',
    },
    leave: {
      name: 'banner-slide-vertical',
      duration: 300,
      easing: 'ease-in-out',
    },
  },
  'fly-in-left-soft': {
    enter: {
      name: 'fly-in-left-soft',
      duration: 450,
      easing: 'cubic-bezier(.22, 1, .36, 1)',
    },
    leave: {
      name: 'fly-in-left-soft',
      duration: 250,
      easing: 'ease-in-out',
    },
  },
  'fly-in-right-soft': {
    enter: {
      name: 'fly-in-right-soft',
      duration: 450,
      easing: 'cubic-bezier(.22, 1, .36, 1)',
    },
    leave: {
      name: 'fly-in-right-soft',
      duration: 250,
      easing: 'ease-in-out',
    },
  },
};
